import alt from 'alt'
import { createStore } from 'alt-utils/lib/decorators'
import { OnboardingActions } from 'actions'

@createStore(alt)
export default class OnboardingStore {
  constructor() {
    // get the onboarding values from localStorage if they're there
    const onboarding = localStorage.getItem('onboarding')
    if (onboarding) {
      const parsed = JSON.parse(onboarding)
      this.state = {
        trialAccepted: parsed.trialAccepted
      }
    } else {
      // null = unknown
      // unknown is expected as we only hold these values in localStorage, changing browsers etc. loses them
      // don't bother to put nulls into localStorage
      this.state = {
        trialAccepted: null
      }
    }

    this.bindActions(OnboardingActions)
  }

  static displayName = 'OnboardingStore'

  setTrialAccepted(trialAccepted) {
    localStorage.setItem('onboarding', JSON.stringify({
      trialAccepted
    }))
    this.setState({ trialAccepted })
  }
}



// WEBPACK FOOTER //
// ./app/stores/OnboardingStore.js